import React, { useEffect, useState } from "react";
import SqrPaymentTransactionsModal from "./SqrPaymentTransactionsModal";
import {
  clearAllPaymentFlowState,
  getPendingSqrPaymentDetail,
  SQR_PAYMENT_SHOW_EVENT,
} from "utilities/onlinePaymentFlow";

const SqrPaymentHost = () => {
  const [sqrPaymentDetail, setSqrPaymentDetail] = useState(null);

  useEffect(() => {
    const pending = getPendingSqrPaymentDetail();
    if (pending) {
      setSqrPaymentDetail(pending);
    }

    const handleSqrPaymentShow = (event) => {
      setSqrPaymentDetail(event.detail || null);
    };

    window.addEventListener(SQR_PAYMENT_SHOW_EVENT, handleSqrPaymentShow);

    return () => {
      window.removeEventListener(SQR_PAYMENT_SHOW_EVENT, handleSqrPaymentShow);
    };
  }, []);

  const dismissModal = () => {
    setSqrPaymentDetail(null);
  };

  const handleCloseWithCleanup = () => {
    clearAllPaymentFlowState();
    setSqrPaymentDetail(null);
  };

  return (
    <SqrPaymentTransactionsModal
      isOpen={Boolean(sqrPaymentDetail)}
      detail={sqrPaymentDetail}
      onClose={handleCloseWithCleanup}
      onDismiss={dismissModal}
    />
  );
};

export default SqrPaymentHost;
